<template>
	<v-dialog v-model="paymentPolicyDialog" width="500">
		<template v-slot:activator="{ on }">
			<v-btn :color="themeInputColor" dark v-on="on" flat small>
				<span class="underline caption px-3">View Payment Policy</span>
			</v-btn>
		</template>

		<v-card>
			<v-card-title class="headline grey lighten-2" primary-title>Payment Policy*</v-card-title>

			<v-card-text class="pa-4">
				<strong>For Sign-Ups</strong> (referral):
				<ul>
					<li>
						<span>&#8377;</span> 15 for each sign-up, with a maximum you can earn upto
						<span>&#8377;</span> 1875 in a month.
					</li>
				</ul>
				<br />
				<strong>For Content Creation:</strong>
				<ul>
					<li>
						<span>&#8377;</span> 15 for each content created but at least 3 posts must be created to be eligible for the reward. And you can earn upto
						<span>&#8377;</span> 1125 in a month.
					</li>
				</ul>
				<br />
				<strong>Bonus:</strong>
				<ul>
					<li>
						If you get 150 sign-ups in a month, you will be receive an extra
						<span>&#8377;</span> 200 as a bonus and if you get 200 sign-ups you will receive another
						<span>&#8377;</span> 300 as a bonus.
					</li>
					<li>
						Also if you create contents everyday for a month, you will be eligible for
						<span>&#8377;</span> 300 as a bonus.
					</li>
				</ul>
				<br />
				<div class="text-xs-right caption grey--text">*Payment policy is subject to change.</div>
			</v-card-text>

			<v-divider></v-divider>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: "PaymentPolicy",
	props: ["themeInputColor"],
	data() {
		return {
			paymentPolicyDialog: false
		};
	}
};
</script>

<style lang="scss" scoped>
ul li {
	margin: 6px 0;
}
</style>
